'use client'

import { Accordion as AccordionPrimitive } from '@base-ui/react/accordion'
import { cn } from '@/lib/utils'

/*
 * Accordion primitives (Base UI). The GoodUnited source accordion in
 * src/components/ui/source-accordion.tsx composes these: SourceList -> Source -> Group -> DetailRow.
 */
function Accordion({ className, ...props }: Omit<AccordionPrimitive.Root.Props, 'className'> & { className?: string }) {
    return (
        <AccordionPrimitive.Root
            data-slot='accordion'
            className={cn('flex w-full flex-col', className)}
            {...props}
        />
    )
}

function AccordionItem({ className, ...props }: Omit<AccordionPrimitive.Item.Props, 'className'> & { className?: string }) {
    return (
        <AccordionPrimitive.Item
            data-slot='accordion-item'
            className={className}
            {...props}
        />
    )
}

function AccordionTrigger({ className, ...props }: Omit<AccordionPrimitive.Trigger.Props, 'className'> & { className?: string }) {
    return (
        <AccordionPrimitive.Header className='flex'>
            <AccordionPrimitive.Trigger
                data-slot='accordion-trigger'
                className={cn('group/accordion-trigger flex w-full cursor-pointer items-center text-left outline-none focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-border-focus', className)}
                {...props}
            />
        </AccordionPrimitive.Header>
    )
}

function AccordionContent({ className, ...props }: Omit<AccordionPrimitive.Panel.Props, 'className'> & { className?: string }) {
    return (
        <AccordionPrimitive.Panel
            data-slot='accordion-content'
            className={cn('h-(--accordion-panel-height) overflow-hidden transition-[height] duration-200 ease-out data-ending-style:h-0 data-starting-style:h-0', className)}
            {...props}
        />
    )
}

export { Accordion, AccordionContent, AccordionItem, AccordionTrigger }
